import jwtAuthKioskAxios from "../auth/jwtAuthKiosk";
import { setBackendDomain } from "./management";

/**
 * GET /api/v1/menu-board
 * Load list of menu boards for the current customer.
 */
export const getMenuBoardList = async () => {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.get("/api/v1/menu-board");
  const body = data?.data ?? data;
  if (Array.isArray(body)) return body;
  return body?.menuBoards ?? body?.menuBoard ?? [];
};

/**
 * PUT /api/v1/menu-board
 * Sends full form payload. Used for both create and edit.
 */
export const putMenuBoard = async (payload) => {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.put("/api/v1/menu-board", payload);
  return data?.data ?? data;
};

/**
 * GET /api/v1/menu-board/id/:id
 * Load single menu board for edit mode.
 */
export const getMenuBoard = async (id) => {
  setBackendDomain(jwtAuthKioskAxios);
  const { data } = await jwtAuthKioskAxios.get(`/api/v1/menu-board/id/${id}`);
  return data?.data ?? data;
};

/**
 * DELETE /api/v1/menu-board/:id
 */
export const deleteMenuBoard = async (id) => {
  setBackendDomain(jwtAuthKioskAxios);
  await jwtAuthKioskAxios.delete(`/api/v1/menu-board/${id}`);
};
